// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Pokušaj ponovo pomoću potpunog datuma kao što je ovaj: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Vrijednost',
  checkboxSet_requiredMessageDetail: () => 'Obavezno',
  checkbox_requiredMessageDetail: () => 'Obavezno',
  close: () => 'Zatvori',
  collection_noData: () => 'Nema podataka za prikaz.',
  collection_selectAllRows: () => 'Izaberi sve redove',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Izaberi red ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ne može se poredati',
  collection_sortEnabled: () => 'Može se poredati',
  confirmation: () => 'Potvrda',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' od ' + p['totalCount'],
  dataVisualization_noData: () => 'Nema podataka za prikaz',
  dataVisualization_stateSelected: () => 'Izabrano',
  dataVisualization_stateUnselected: () => 'Nije izabrano',
  error: () => 'Greška',
  expandableList_expandCollapseInstructionText: () =>
    'Koristi tipke sa strelicama za proširivanje i sužavanje',
  expandableList_groupCollapse: () => 'Sažeto',
  expandableList_groupExpand: () => 'Prošireno',
  filePicker_addFiles: () => 'Dodaj datoteke',
  filePicker_dropzonePrimaryText: () => 'Povuci i ispusti',
  filePicker_dropzoneSecondaryText: () => 'Izaberi datoteku ili ispusti neku ovdje',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izaberi ili ispusti datoteke ovdje',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete učitati datoteke vrste ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Učitaj jednu po jednu datoteku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete učitati datoteke vrste ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  formControl_clear: () => 'Očisti',
  formControl_day: () => 'Dan',
  formControl_helpAvailable: () => 'Dostupna je pomoć',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'You’ve reached the limit of ' +
    (({ one: '1 character' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('bs').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('bs').format(p['CHARACTER_LIMIT']) + ' characters') +
    '.',
  formControl_loading: () => 'Učitavanje',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Prekoračena je maksimalna dužina od ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostalo znakova: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Mjesec',
  formControl_readOnly: () => 'Samo za čitanje',
  formControl_requiredMessageDetail: () => 'Unesi vrijednost.',
  formControl_year: () => 'Godina',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Kraj',
  gantt_labelLabel: () => 'Oznaka',
  gantt_labelRow: () => 'Red',
  gantt_labelStart: () => 'Početak',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nije pronađen nijedan podudaran odjeljak.',
  indexer_keyboardInstructionText: () => 'Pritisni Enter za izbor vrijednosti.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvaput dodirnuti i držati. Čekati na zvuk i onda prevući da bi se preuredilo.',
  info: () => 'Informacije',
  inputDateMask_date_cleared: () => 'Datum je izbrisan',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prazno',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'gggg',
  inputNumber_converterParseError: () => 'Unesi broj.',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_increase: () => 'Povećaj',
  inputPassword_hidden: () => 'Lozinka je skrivena',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_show: () => 'Prikaži lozinku',
  list_suggestion: () => 'Prijedlog',
  messageToast_allMessagesClosed: () => 'Sve toast poruke su zatvorene.',
  message_close: () => 'Zatvori',
  message_confirmation: () => 'Uspješno',
  message_error: () => 'Greška',
  message_info: () => 'Informacije',
  message_navigationFromMessagesRegion: () =>
    'Područje za unošenje poruka. Pritisnite F6 za povratak na prethodno fokusirani element.',
  message_navigationToMessagesRegion: () =>
    'Područje za poruke sadrži nove poruke. Pritisnite F6 za prelazak na područje s najnovijim porukama.',
  message_warning: () => 'Upozorenje',
  noData_message: () => 'Nema stavki za prikaz',
  overflowItemLabel: () => 'Više kartica',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'U toku',
  radio_helpForRadio: () => 'Pomoć za izborno dugme',
  radio_requiredMessageDetail: () => 'Izaberi vrijednost.',
  selectMultiple_apply: () => 'Primijeni',
  selectMultiple_back: () => 'Nazad',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite Backspace ili Delete da uklonite izabrane vrijednosti.',
  selectMultiple_selectedValues: () => 'Izabrane vrijednosti',
  selectMultiple_showSelectedValues: () => 'Prikaži samo izabrane vrijednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izabrano vrijednosti: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Dodaj na spisak',
  select_addToListAvailable: () => 'Dostupno je dodavanje na spisak',
  select_moreSearchOptions: () => 'Više opcija pretraživanja',
  select_moreSearchOptionsAvailable: () => 'Dostupno je više opcija pretraživanja',
  select_noMatchesFound: () => 'Nije pronađeno nijedno podudaranje.',
  select_oneMatchFound: () => 'Pronađeno je jedno podudaranje',
  select_requiredMessageDetail: () => 'Izaberi vrijednost.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađeno podudaranja: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađeno podudaranja: najmanje ' + p['TOTAL_SIZE'],
  selector_selected: () => 'Okvir je potvrđen',
  selector_unselected: () => 'Okvir nije potvrđen',
  tabBarNavigationList_removeCueText: () => 'Može se ukloniti',
  timeComponent_tooltipZoomIn: () => 'Uvećaj',
  timeComponent_tooltipZoomOut: () => 'Umanji',
  train_current: () => 'Trenutno',
  train_message_type: () => 'Vrsta poruke',
  train_not_visited: () => 'Nije posjećeno',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_visited: () => 'Posjećeno',
  userAssistance_learnMore: () => 'Saznaj više',
  userAssistance_required: () => 'Obavezno',
  viz_drillable: () => 'Raščlanjivo',
  warn: () => 'Upozorenje'
};
export default bundle;
